import { reactive } from 'vue';
import { ModalController, ModalControllerParams } from '@/common/components/modal/ModalController';

export function useModal<T>(params?: ModalControllerParams<T>) {
    return reactive(new ModalController<T>(params));
}
